/** IdleMon Pokédex runtime helpers. */
import { encounterLocationsForSpecies, evolutionDepthForSpecies } from './battle-data.js';
import { capturedPokemonSellPrice } from './economy-balance.mjs';

let pokedexData = null;
let loadPromise = null;

export async function loadPokedexData() {
  if (pokedexData) return pokedexData;
  if (loadPromise) return loadPromise;
  loadPromise = fetch('public/game/pokedex.json')
    .then((r) => r.json())
    .then((json) => {
      pokedexData = json;
      return pokedexData;
    });
  return loadPromise;
}

export function isPokedexReady() {
  return !!pokedexData;
}

export function allPokedexSpecies() {
  return pokedexData?.species || [];
}

export function pokedexEntry(slugOrId) {
  if (!pokedexData) return null;
  if (typeof slugOrId === 'number' || /^\d+$/.test(String(slugOrId))) {
    return pokedexData.species.find((s) => s.id === Number(slugOrId)) || null;
  }
  const key = String(slugOrId).toLowerCase().replace(/_/g, '-');
  return pokedexData.bySlug?.[key] || null;
}

/** Onde a espécie aparece nas rotas tipadas (faixas de nível). */
export function speciesLocations(slugOrId) {
  const entry = pokedexEntry(slugOrId);
  const slug = entry?.slug || String(slugOrId || '').toLowerCase().replace(/_/g, '-');
  if (!slug) return [];
  return encounterLocationsForSpecies(slug).map((location) => ({
    type: location.type,
    mode: location.mode,
    zoneId: location.zoneId,
    legendaryBoss: !!location.legendaryBoss,
    bands: location.bands.map((band) => band.range),
    chances: location.bands.map((band) => band.chance),
    levelMin: location.bands[0].range[0],
    levelMax: location.bands.at(-1).range[1],
  }));
}

/** Fator 0–1: quanto mais baixo o catchRate / mais alto o estágio, mais difícil. */
export function speciesCatchFactor(entry) {
  const rate = Math.max(3, Math.min(255, Number(entry?.catchRate) || 45));
  const rateFactor = Math.pow(rate / 255, 0.55);
  const stage = Math.max(0, evolutionDepthForSpecies(entry?.slug));
  const stageFactor = [1, 0.72, 0.48, 0.36][Math.min(stage, 3)];
  let rarityFactor = 1;
  const sell = Number(entry?.sellPrice) || 5000;
  if (entry?.legendary || sell >= 100000) rarityFactor = 0.22;
  else if (sell >= 50000) rarityFactor = 0.4;
  else if (sell >= 25000) rarityFactor = 0.62;
  return Math.max(0.035, Math.min(1.15, rateFactor * stageFactor * rarityFactor));
}

export function catchDifficultyLabel(entry) {
  const f = speciesCatchFactor(entry);
  if (f >= 0.7) return 'Fácil';
  if (f >= 0.45) return 'Média';
  if (f >= 0.22) return 'Difícil';
  return 'Muito difícil';
}

/** Preço de venda de um exemplar capturado. */
export function pokemonSellPrice(pokemon, entry) {
  return capturedPokemonSellPrice(pokemon, entry?.sellPrice || 5000);
}

export function formatDexNumber(id) {
  return `#${String(id).padStart(3, '0')}`;
}
